var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row content-box full-height full_page"},[_c('woot-wizard',{staticClass:"hide-for-small-only medium-3 columns",attrs:{"global-config":_vm.globalConfig,"items":_vm.finalizedItems}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }